import { Box, Heading as ChakraHeading } from "@chakra-ui/react"
import usePageStyling from "src/hooks/usePageStyling"

function Heading() {
  return <></>
}

Heading.Default = ({ title }: { title: string }) => {
  const roomStyles = usePageStyling("authPageStyling")      
  return (
    <ChakraHeading
      fontSize={"4xl"}
      textAlign="center"
      paddingBottom="8px"
      color={
        roomStyles?.authPagePanelTextColor
          ? roomStyles?.authPagePanelTextColor
          : "#4A5568"
      }
    >
      {title}
    </ChakraHeading>
  )
}

Heading.Learnmachine = ({
  title,
  isMobileLandscape
}: {
  title: string
  isMobileLandscape: boolean
}) => {
  return (
    <>
      <ChakraHeading
        fontSize={"4xl"}
        textAlign="center"
        color={"white"}
        opacity={"0.85"}
      >
        {title}
      </ChakraHeading>
      {!isMobileLandscape && (
        <Box
          maxW="180px"
          height="4px"
          margin="15px 0px !important"
          width="100%"
          borderTop="1px solid orange"
          borderBottom="1px solid orange"
        />
      )}
    </>
  )
}

export default Heading
